export default __webpack_public_path__ + "static/11-d4cb38fc6e61e69abd7e8cccfc1e92ff.png";